import { useEffect } from "react";
import Cookies from "js-cookie";

export default function AuthSuccess() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const token = params.get("token");
    const userId = params.get("userId");
    const name = params.get("name");

    if (!token || !userId) {
      window.location.href = "/";
      return;
    }

    // ✅ Store exactly what navbar & orders expect
    Cookies.set("token", token, { expires: 30 });
    Cookies.set("userId", userId, { expires: 30 });

    if (name) {
      Cookies.set("user", decodeURIComponent(name), { expires: 30 });
    }

    window.location.href = "/";
  }, []);

  return <p>Logging you in...</p>;
}
